// AllServicesShowcase.js
// Reusable component that combines all service showcase sections
import React from 'react';
import CustomizedCareSection from './CustomizedCareSection';
import ServicesShowcaseSection from './ServicesShowcaseSection';
import AdditionalServicesSection from './AdditionalServicesSection';
import FinalServicesSection from './FinalServicesSection';
import RespiteCareSection from './RespiteCareSection';

const AllServicesShowcase = () => {
  return (
    <>
      <CustomizedCareSection />
      <ServicesShowcaseSection />
      <AdditionalServicesSection />
      <FinalServicesSection />
      <RespiteCareSection />
    </>
  );
};

export default AllServicesShowcase;
